/**
 * Read stored OIDC access token (sessionStorage preferred, localStorage legacy fallback).
 */
export function readStoredAccessToken(): string | undefined {
  if (typeof window === 'undefined') return undefined
  try {
    const raw =
      sessionStorage.getItem('authToken') || localStorage.getItem('authToken')
    if (!raw) return undefined
    const parsed = JSON.parse(raw) as { access_token?: string }
    return parsed.access_token
  } catch {
    return undefined
  }
}

export function readStoredAuthTokenJson(): string | null {
  if (typeof window === 'undefined') return null
  return sessionStorage.getItem('authToken') || localStorage.getItem('authToken')
}
